<template>
<div :ref="LoadingObj" class="ttl-goods-box-left">    
    <div class="TTL-el-form-search-regular" style="display:inline-block;width:100%;">
        <span class="TTL-title">商品详情</span>
        <div class="TTL-BTN-LIST">
            <wcbutton :option="{title:'返回商品管理',type:'del'}" class="left15" @finish="(val)=> {$parent.JUMPVIEW({name:'EsGoods'})}" />
        </div>
    </div>
    
    <div class="ttl-goods top20 bottom30">
        <div class="ttl-member" @click="$parent.JUMPVIEW({name:'EsMemberDetail',param:{id:goodsinfo.memberid}})">
            <el-image :src="goodsinfo.memberthumb" fit="cover"/>
            <div class="ttl-member-user-phone left15">
            <span class="ttl-member-info">{{goodsinfo.membername}}</span>
            </div>
        </div>
        <div class="ttl-banner top30">
            <el-carousel height="400px">
                <el-carousel-item v-for="(item,index) in goodsinfo.photos" :key="index">
                <el-image :src="item.url" fit="cover"/>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="ttl-goods-price top20">
            <i>售价</i>{{goodsinfo.price}}
            <span>{{goodsinfo.type}}</span>
        </div>
        <div class="ttl-goods-names ttl-bold top10">【{{goodsinfo.catename}}】* {{goodsinfo.name}}</div>
        <div class="ttl-goods-names top10" v-if="goodsinfo.note!=''">{{goodsinfo.note}}</div>
        <div class="ttl-yimiao top10" v-if="goodsinfo.Fineness!=''">{{goodsinfo.Fineness}}</div>
    </div>        
</div>

<!-- 评论信息列表 -->
<div class="comment-box-out" @scroll="handleScroll($event)" v-loading="commentparam.isloading">
<el-empty description="暂无商品评论数据" v-if="commentlists.length==0" />
<div class="comment-box">
    <div class="comment-box-info" v-for="(item,index) in commentlists" :key="index">
        <i class="cover" />
        <div @click="$parent.JUMPVIEW({name:'EsMemberDetail',param:{id:item.frommemberid}})">
        <el-image :src="item.frommemberthumb" />
        </div>
        <div class="comment-box-info-content">
            <div class="comment-box-info-content-in">
                <span class="comment-name">{{item.frommembername}}</span>
                <span class="comment-time">{{item.inputtime}}</span>
            </div>
            <div class="comment-box-info-content-in top10">
                <span class="comment-answer"><i>{{item.tomembername}}</i>{{item.content}}</span>
            </div>
        </div>
    </div>
</div>
</div>
</template>

<script>
import INTERFACE_MODEL_GOODS from '@/Interface/Es/Goods/Goods';
import AddBrand from './Module/AddBrand.vue';

export default {
    components:{AddBrand},
    data() {
        return {
            LoadingObj:'GoodsDetail',  //loading对象   
            goodsinfo:{}, //商品信息 
            commentparam: {
                isloading:false,
                isfinish:false,
                goodsid:'',
                p:0,
                rollpage:10,
            },
            commentlists:[],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.GetGoodsInfo(data.param.id);
                this.GetGoodsComment(data.param.id);
            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetGoodsInfo(data.param.id);
                this.GetGoodsComment(data.param.id);
            } 
        },


        /** 获取商品信息详情 **/
        GetGoodsInfo(id) {
            var obj=this.$refs[this.LoadingObj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_GOODS.GET_GOODS_INFO({id:id}).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.goodsinfo=res.data;
            });
        },


        /** 获取商品评论信息 **/
        GetGoodsComment(id) {
            this.commentparam.goodsid=id;
            this.commentparam.p=0;
            this.commentparam.isloading=false;
            this.commentparam.isfinish=false;
            this.commentlists=[];
            this.GetCommentList();
        },

        
        /** 获取商品评论信息列表 **/
        GetCommentList() {
            if(this.commentparam.isfinish) return false;
            if(this.commentparam.isloading) return false;
            this.commentparam.isloading=true;

            this.commentparam.p++;
            INTERFACE_MODEL_GOODS.GET_COMMENT_LIST(this.commentparam).then((res) => {
                 this.commentparam.isloading=false;
                 if(res.status > 0) return false;
                 if(res.data.list.length==0) this.commentparam.isfinish=true;
                 for(var i=0; i < res.data.list.length; i++) this.commentlists.push(res.data.list[i]);
            });
        },


        //滚动触发操作
        handleScroll(event) {
            const{ scrollTop, scrollHeight, clientHeight }=event.target;
            //检查是否滚动到底部
            const isBottom = scrollHeight - (scrollTop + clientHeight) < 100; // 这里的1是一个阈值，可以根据需要调整
            if(isBottom) {
                this.GetCommentList();
            }
        },


    },
}
</script>
<style scoped>
::-webkit-scrollbar {width:0;}
.ttl-goods {display: inline-block;width:50%;}
.ttl-member {display:inline-flex;align-items: center;width:100%;height: 70px;background-color: #ffffff;position:sticky;z-index:30;top:85px;cursor: pointer;}
.ttl-member .el-image {width:40px;height: 40px;border-radius: 50%;}
.ttl-member-info {font-size:13px;color:#666666;display: inline-block;width:100%;}
.ttl-member-info i {font-style:normal;font-size:12px;color:#666eeb;}
.ttl-member-info h {font-style:normal;font-size:12px;color:#666666;position:absolute;right:0;}
.ttl-banner {display: inline-block;width:100%}
.ttl-banner .el-image {width:100%;height: 400px;}
.ttl-goods-names {display: inline-block;width:100%;font-size:13px;color:#666666;line-height: 21px;}
.bottom30 {margin-bottom: 30px;}
.ttl-bold {font-weight: 550;font-size: 14px;}
.ttl-goods-price {display: inline-flex;align-items: center;width:100%;font-size:22px;color:#e32020;font-weight: 650;position:relative;}
.ttl-goods-price i {font-size:12px;font-style:normal;color:#666666;margin-right:5px;margin-top:5px;font-weight: normal;}
.ttl-goods-price span {position:absolute;font-size:13px;right:0;color:#666666;font-weight: normal;}
.ttl-goods-spec {display: inline-flex;justify-content: center;width:100%;}
.ttl-goods-spec-info {display: inline-block;padding:0 10px;width:calc(20% - 20px);border-right: 1px solid #E4E7ED;text-align: center;}
.ttl-goods-spec-info:last-child {border-right:none;}
.ttl-goods-spec-name {display: inline-block;width:100%;font-size:13px;text-align: center;color:#666666;}
.ttl-goods-spec-value {display: inline-block;width:100%;font-size:13px;text-align: center;color:#999999;}
.ttl-goods-photos {display: inline-block;width:100%;}
.ttl-goods-photos .el-image {display: inline-block;width:100%;}
.ttl-member-user-phone {display: inline-block;width:calc(100% - 40px - 10px);}
.phone {font-size:12px;color:#999999;}
.ttl-goods-box-left {position:absolute;padding:0 20px;width:calc(70% - 40px);left:0;top:0;height: 100%;overflow-y:auto;}

.comment-box-out {position:absolute;width:30%;height:calc(100% - 60px);overflow-y:auto;top:0;right:0;z-index: 20;padding:30px 0;}
.comment-box {width:calc(100% - 40px);top:0;right:0;padding:0 20px;}
.comment-box-info {display:inline-flex;width:calc(100% - 20px - 2px);padding:35px 20px;border-left:2px solid #dddddd;position:relative;margin-bottom:10px;}
.comment-box-info .cover {width:15px;height: 15px;border-radius: 50%;background-color: #dddddd;position:absolute;top:0;left:0;margin-left:-8px;margin-top:-8px;}
.comment-box-info:first-child {border-left:2px solid #666eeb;}
.comment-box-info:first-child .cover {background-color: #666eeb;}
.comment-box-info .el-image {width:50px;height:50px;border-radius: 50%;box-shadow: 0 0 10px #dddddd;cursor: pointer;}
.comment-box-info-content {display:inline-block;position:relative;width:calc(100% - 50px - 20px);margin-left:20px;min-height: 50px;}
.comment-box-info-content-in {display:inline-flex;width:calc(100% - 50px - 20px);}
.comment-name {font-size:13px;color:#333333;line-height: 18px;}
.comment-time {position:absolute;right:0;font-size:13px;color:#333333;}
.comment-answer {display: inline-block;width:100%;font-size:13px;line-height: 20px;letter-spacing: 1px;color:#666666;}
.comment-answer i {font-style: normal;color:#666eeb;}
.ttl-yimiao {font-size:12px;padding:5px 20px;border-radius: 15px;color:#333333;border:1px solid #dfc471;display: inline-block;}
</style>